<template>
  <div class="cf-root">
    <chat-panel :fullscreen="true" />
  </div>
</template>

<script>
import ChatPanel from './ChatPanel'

export default {
  name: 'CortexFullscreen',
  components: { ChatPanel }
}
</script>

<style scoped>
.cf-root {
  display: flex;
  height: 100vh;
  overflow: hidden;
  background: #1a1d27;
}
</style>
